import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'Biblioteca de Hooks para Infoproductores',
  desc: '50 hooks probados para vender cursos, membresías, eBooks y programas online. Alineados con los 24 ángulos psicológicos. Listos para usar en Meta Ads.',
  image: 'https://i.postimg.cc/DZPhTh3V/Libro-1.webp'
}, {
  id: 2,
  title: 'Manual de Estructuras de Anuncios',
  desc: '10 estructuras que mejor convierten: carruseles, guiones de Reels, VSLs de alto impacto y plantillas de imagen estática con ángulos estratégicos.',
  image: 'https://i.postimg.cc/y83zNcCf/libro-2.webp'
}, {
  id: 3,
  title: 'Checklist de Testing para Infoproductores',
  desc: 'Checklist paso a paso para testear 5 ángulos en 7 días. Incluye métricas clave: CTR, CPL, CPA, ROAS. Diseñado para media buyers de infoproductos.',
  image: 'https://i.postimg.cc/yYWMfcxx/libro-3.webp'
}, {
  id: 4,
  title: 'Guión de VSL para Lanzamiento',
  desc: 'Guión listo para grabar una VSL de 5 minutos: Hook, Problema, Solución, Prueba, Oferta y Cierre con Urgencia. Solo grabás siguiendo el guión.',
  image: 'https://i.postimg.cc/s2PqBJ6L/libro-4.webp'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function BonusSection() {
  return <section className="bg-black py-16 px-4 relative overflow-hidden border-t border-matrix-green/10" data-id="element-37">
      {/* Background accents */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-matrix-green/5 blur-[120px] pointer-events-none" data-id="element-38" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-39">
        <div className="text-center mb-10" data-id="element-40">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center gap-2 bg-matrix-green/10 border border-matrix-green/30 px-4 py-2 rounded-full mb-6" data-id="element-41">
            <Gift className="w-5 h-5 text-matrix-green" data-id="element-42" />
            <span className="text-matrix-green font-mono text-sm font-bold uppercase tracking-wider" data-id="element-43">
              Regalos Exclusivos
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-44">
            Llevate estos{' '}
            <span className="text-matrix-green text-glow-green" data-id="element-45">
              4 Bonos de Acción Rápida
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-body text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-46">
            Al descargar PromptAdsPro hoy, también te llevás esta biblioteca
            exclusiva en PDF para potenciar tus resultados al máximo.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-47">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} variants={itemVariants} className="group relative bg-white/5 border border-matrix-green/20 rounded-2xl p-6 hover:border-matrix-green/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,255,65,0.15)] flex flex-col sm:flex-row items-center sm:items-start gap-6" data-id="element-48">
              <div className="absolute inset-0 bg-gradient-to-b from-matrix-green/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl pointer-events-none" data-id="element-49" />

              {/* Image */}
              <div className="relative w-36 sm:w-40 flex-shrink-0 transform group-hover:-translate-y-1 transition-transform duration-300" data-id="element-50">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-51" />
              </div>

              {/* Content */}
              <div className="relative z-10 text-center sm:text-left flex-1" data-id="element-52">
                <span className="inline-block text-matrix-green font-mono text-xs font-bold uppercase tracking-wider mb-2 bg-matrix-green/10 px-2 py-0.5 rounded" data-id="element-53">
                  Bono {bonus.id}
                </span>
                <h3 className="font-heading font-bold text-lg text-white mb-2 group-hover:text-matrix-green transition-colors leading-tight" data-id="element-54">
                  {bonus.title}
                </h3>
                <p className="font-body text-sm text-gray-400 leading-relaxed mb-3" data-id="element-55">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 justify-center sm:justify-start" data-id="element-56">
                  <span className="text-gray-500 line-through text-sm font-body" data-id="element-57">
                    USD $20
                  </span>
                  <span className="bg-matrix-green/20 text-matrix-green font-mono font-bold text-xs px-3 py-1 rounded-full border border-matrix-green/30 shadow-[0_0_10px_rgba(0,255,65,0.2)]" data-id="element-58">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}